import * as React from 'react';

import AdminSyncTypePickerModal from 'admin/rostering/components/AdminSyncTypePickerModal';
import Button from 'components/ButtonDeprecated';
import Heading from 'components/Heading';
import Link from 'components/Link';
import Modal from 'react-modal';
import Row from 'components/Row';
import Text from 'components/Text';
import LinkConstants from 'constants/LinkConstants';
import ValuePropConstants from 'constants/ValuePropConstants';
import ValuePropsRow from 'components/ValuePropsRow';
import { SyncType } from 'globalTypes';

type Props = {
  orgName: string;
  selectSyncType: (method: SyncType) => void;
};

type State = {
  sisSyncPickerModalIsOpen: boolean;
};

class AdminStartSisSyncSetup extends React.Component<Props, State> {
  state: State = {
    sisSyncPickerModalIsOpen: false,
  };

  showSisSyncPickerModal = () => {
    this.setState({ sisSyncPickerModalIsOpen: true });
  };

  hideSisSyncPickerModal = () => {
    this.setState({ sisSyncPickerModalIsOpen: false });
  };

  render() {
    const { orgName, selectSyncType } = this.props;
    let startSisSyncValueProps = [
      ValuePropConstants.START_SIS_SYNC_LIST_FORMAT_FILES,
      ValuePropConstants.START_SIS_SYNC_SEND_DATA,
      ValuePropConstants.START_SIS_SYNC_REVIEW,
    ];

    return (
      <div className="AdminStartSisSyncSetup">
        <Modal isOpen={this.state.sisSyncPickerModalIsOpen}>
          <AdminSyncTypePickerModal
            orgName={orgName}
            onClose={this.hideSisSyncPickerModal}
            selectSyncType={selectSyncType}
          />
        </Modal>
        <Row size="xxxlarge">
          <Heading align="center" levelStyle="2">
            Sync Remind with your SIS
          </Heading>
          <Text align="center" size="medium" color="graphite">
            Create accounts and classes for your entire community that update with your SIS.
          </Text>
        </Row>
        <Row size="xxxxxlarge">
          <ValuePropsRow valueProps={startSisSyncValueProps} />
        </Row>
        <Text align="center" element="section">
          <Row>
            <Button
              onClick={() => this.showSisSyncPickerModal()}
              level="primary"
              color="mascot"
              weight="semibold"
              data-test="start-sis-setup">
              Start SIS sync setup
            </Button>
          </Row>
          <Row>
            <Link target="_blank" href={LinkConstants.ROSTERING_GUIDE} weight="semibold">
              Learn more
            </Link>
          </Row>
        </Text>
      </div>
    );
  }
}

export default AdminStartSisSyncSetup;
